import React, { useState } from 'react';

// MUI Components
import { Box, Tabs, Tab, GlobalStyles, Card, CardContent } from '@mui/material';

// Local Components
import Import from './Import';
import Export from './Export';

import './style.scss';

const ImportExport = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <GlobalStyles
        styles={{
          body: { backgroundColor: '#F9FAFB' },
        }}
      />

      <Box className="olcWrapper importExportPageWrapper">
        <Card className="tabsScreenCard importExportScreenCard">
          <Box className="importExportTabsHeader">
            <Tabs
              className="importExportTabs"
              value={activeTab}
              onChange={handleChange}
              aria-label="Import Export Tabs"
            >
              <Tab label="Imports" id="import-tab" aria-controls="import-panel" disableRipple />
              <Tab label="Exports" id="export-tab" aria-controls="export-panel" disableRipple />
            </Tabs>
          </Box>
          <CardContent className="importExportCardContent">
            <Box
              className="importExportTabPanel"
              role="tabpanel"
              hidden={activeTab !== 0}
              id="import-panel"
              aria-labelledby="import-tab"
            >
              {activeTab === 0 && <Import />}
            </Box>

            <Box
              className="importExportTabPanel"
              role="tabpanel"
              hidden={activeTab !== 1}
              id="export-panel"
              aria-labelledby="export-tab"
            >
              {activeTab === 1 && <Export />}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ImportExport;
